import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e95d899"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "lookUpValue-wrapper"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "lookUpValue-wrapper lookUpItem gray-container" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "handle-block" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-align-justify handle grabbable" }, null, -1))
const _hoisted_7 = { class: "info-container" }
const _hoisted_8 = {
  key: 1,
  class: "pi pi-info-circle"
}
const _hoisted_9 = {
  key: 0,
  class: "right-aligned-items"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsDropdown = _resolveComponent("AsDropdown")!
  const _component_AsInput = _resolveComponent("AsInput")!
  const _component_AsReadWriteBlock = _resolveComponent("AsReadWriteBlock")!
  const _component_fa = _resolveComponent("fa")!
  const _component_AsButton = _resolveComponent("AsButton")!
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (!_ctx.lookUpValue.id)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_AsDropdown, {
          clearIcon: true,
          class: "type-search",
          placeholder: _ctx.$t('lookUpValues.typePlaceholder'),
          label: _ctx.$t('type'),
          value: _ctx.lookUpValue.type,
          options: _ctx.lookUpValueOptions,
          optionValue: 'key',
          optionLabel: 'value',
          onUpdate: _cache[0] || (_cache[0] = (value) => ((_ctx.lookUpValue.type = value), _ctx.updateModel()))
        }, null, 8, ["placeholder", "label", "value", "options"]),
        _createVNode(_component_AsInput, {
          placeholder: _ctx.$t('name'),
          label: _ctx.$t('name'),
          value: _ctx.lookUpValue.name,
          onUpdate: _cache[1] || (_cache[1] = (value) => ((_ctx.lookUpValue.name = value), _ctx.updateModel()))
        }, null, 8, ["placeholder", "label", "value"]),
        _createVNode(_component_AsInput, {
          placeholder: _ctx.$t('value'),
          label: _ctx.$t('value'),
          value: _ctx.lookUpValue.value,
          onUpdate: _cache[2] || (_cache[2] = (value) => ((_ctx.lookUpValue.value = value), _ctx.updateModel()))
        }, null, 8, ["placeholder", "label", "value"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (!_ctx.isReadOnly)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('type')), 1),
                _createVNode(_component_AsDropdown, {
                  clearIcon: true,
                  class: "type-search",
                  placeholder: _ctx.$t('lookUpValues.typePlaceholder'),
                  value: _ctx.lookUpValue.type,
                  options: _ctx.lookUpValueOptions,
                  optionValue: 'key',
                  optionLabel: 'value',
                  onUpdate: _cache[3] || (_cache[3] = (value) => ((_ctx.lookUpValue.type = value), _ctx.updateModel()))
                }, null, 8, ["placeholder", "value", "options"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_AsReadWriteBlock, {
              label: _ctx.$t('name'),
              value: _ctx.lookUpValue.name,
              isReadOnly: _ctx.isReadOnly
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AsInput, {
                  placeholder: _ctx.$t('name'),
                  value: _ctx.lookUpValue.name,
                  onUpdate: _cache[4] || (_cache[4] = (value) => ((_ctx.lookUpValue.name = value), _ctx.updateModel()))
                }, null, 8, ["placeholder", "value"])
              ]),
              _: 1
            }, 8, ["label", "value", "isReadOnly"])
          ]),
          _createVNode(_component_AsReadWriteBlock, {
            label: _ctx.$t('value'),
            value: _ctx.lookUpValue.value,
            isReadOnly: _ctx.isReadOnly
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AsInput, {
                placeholder: _ctx.$t('value'),
                value: _ctx.lookUpValue.value,
                onUpdate: _cache[5] || (_cache[5] = (value) => ((_ctx.lookUpValue.value = value), _ctx.updateModel()))
              }, null, 8, ["placeholder", "value"])
            ]),
            _: 1
          }, 8, ["label", "value", "isReadOnly"]),
          _createElementVNode("div", _hoisted_7, [
            (!_ctx.lookUpValue.isSystem && !_ctx.lookUpValue.isDeleted && _ctx.isReadOnly)
              ? (_openBlock(), _createBlock(_component_fa, {
                  key: 0,
                  icon: "icon fa-pencil",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.enableEditMode())),
                  class: "cursor-pointer"
                }))
              : _createCommentVNode("", true),
            (_ctx.lookUpValue.isDeleted)
              ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_8, null, 512)), [
                  [_directive_tooltip, { value: _ctx.$t('deleted'), showDelay: 1000, hideDelay: 300 }]
                ])
              : _createCommentVNode("", true)
          ])
        ]),
        (!_ctx.isReadOnly)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_AsButton, {
                type: _ctx.bTypes.Primary,
                label: _ctx.$t('update'),
                disabled: !_ctx.isFormValid,
                onClick: _ctx.updateLookUpValue
              }, null, 8, ["type", "label", "disabled", "onClick"]),
              _createVNode(_component_AsButton, {
                type: _ctx.bTypes.Outlined,
                label: _ctx.$t('cancel'),
                onClick: _ctx.cancel
              }, null, 8, ["type", "label", "onClick"]),
              _createVNode(_component_AsButton, {
                type: _ctx.bTypes.Danger,
                label: _ctx.$t('delete'),
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.deleteLookUpValue($event)))
              }, null, 8, ["type", "label"]),
              _createVNode(_component_ConfirmPopup)
            ]))
          : _createCommentVNode("", true)
      ]))
}